"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CourseCardSummaryPopUp = exports.PopupCourseActivitySummary = exports.OnTimeArgs = exports.WithButtonActionArgs = exports.DefaultCourseActivitySummaryArgs = void 0;
var material_1 = require("@mui/material");
var enums_1 = require("../../shared/enums");
var course_activity_summary_1 = require("./course-activity-summary");
var react_1 = __importDefault(require("react"));
var il_course_card_1 = require("../il-course-card/il-course-card");
exports.DefaultCourseActivitySummaryArgs = {
    subjectIcon: enums_1.CustomIconTypeEnum.CALVERT_ELECTIVE,
    title: 'Theory of Computation 404',
    delayed: true,
    status: 'Behind',
    showProgress: true,
    progressPercent: 50,
    delayPercent: 15,
    activitiesCompleted: 35,
    activitiesOverdue: 10,
    activitiesTotal: 40,
    letterGrade: 'A',
    open: false,
};
exports.WithButtonActionArgs = __assign(__assign({}, exports.DefaultCourseActivitySummaryArgs), { viewCourseLink: '#' });
exports.OnTimeArgs = __assign(__assign({}, exports.WithButtonActionArgs), { delayed: false, delayPercent: 0, activitiesOverdue: 0, status: 'On Time' });
function PopupCourseActivitySummary(_a) {
    var _b = _a.open, open = _b === void 0 ? false : _b, onClose = _a.onClose, dialogProps = _a.dialogProps, props = __rest(_a, ["open", "onClose", "dialogProps"]);
    var fullScreen = (0, material_1.useMediaQuery)(function (theme) { return theme.breakpoints.down('md'); });
    return (react_1.default.createElement(material_1.Dialog, __assign({ onClose: onClose, open: open, maxWidth: "xs", fullScreen: fullScreen, PaperProps: {
            sx: {
                backgroundColor: 'background.default',
                width: '100%',
                maxWidth: { sm: 'auto', md: '22.5rem' }, // 360px
            },
        } }, dialogProps),
        react_1.default.createElement(course_activity_summary_1.CourseActivitySummary, __assign({}, props, { onClose: onClose }))));
}
exports.PopupCourseActivitySummary = PopupCourseActivitySummary;
function CourseCardSummaryPopUp(_a) {
    var _b = _a.open, open = _b === void 0 ? false : _b, onClose = _a.onClose, dialogProps = _a.dialogProps, props = __rest(_a, ["open", "onClose", "dialogProps"]);
    var _c = react_1.default.useState(open), openState = _c[0], setOpen = _c[1];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(il_course_card_1.ILCourseCard, __assign({}, props, { onClick: function () { return setOpen(true); } })),
        react_1.default.createElement(PopupCourseActivitySummary, __assign({}, props, { open: openState, onClose: function () { return setOpen(false); } }))));
}
exports.CourseCardSummaryPopUp = CourseCardSummaryPopUp;
